import { render } from "./NuvemEdit.vue?vue&type=template&id=a1f9589c"
import script from "./NuvemEdit.vue?vue&type=script&lang=js"
export * from "./NuvemEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__